import PreviewNext from './PreviewNext';
import nextBlockTransitionBehavior from './nextBlockTransitionBehavior';

export default nextBlockTransitionBehavior(PreviewNext, 'page');



// WEBPACK FOOTER //
// ./src/components/PreviewNextPage.js